import { useEffect, useRef, useState } from "react";
import { focusNext } from "@/lib/formKeys";

// Keyboard for suggestion lists (same feel as the company picker): ↑/↓ PageUp/PageDown move the highlight, Enter picks, Esc closes.
export function useListKeys(items, { open, setOpen, onPick, shown = open, advance = true }) {
  const [active, setActive] = useState(-1);
  const box = useRef(null);
  const sig = items.map((x) => x.id).join("|");
  useEffect(() => { setActive(-1); }, [sig, open]);
  useEffect(() => {
    if (active >= 0) box.current?.querySelectorAll("[data-opt]")[active]?.scrollIntoView({ block: "nearest" });
  }, [active]);
  const onKeyDown = (e) => {
    const step = { ArrowDown: 1, ArrowUp: -1, PageDown: 5, PageUp: -5 }[e.key];
    if (step) {
      e.preventDefault();
      if (!open) { setOpen(true); return; }
      if (items.length) setActive((a) => Math.max(0, Math.min(items.length - 1, (a < 0 ? (step > 0 ? -1 : items.length) : a) + step)));
    } else if (e.key === "Enter" && open && items[active]) {
      e.preventDefault();
      onPick(items[active]);
      setOpen(false);
      if (advance) focusNext(e.currentTarget);
    } else if (e.key === "Escape" && shown) {
      setOpen(false);
    }
  };
  const opt = (i) => ({ "data-opt": "", "data-active": i === active ? "" : undefined, onMouseEnter: () => setActive(i) });
  const input = { onKeyDown, "data-suggest-open": shown ? "" : undefined };
  return { box, input, opt };
}
